import React from "react";
import PropTypes from "prop-types";
import Carousel from "@brainhubeu/react-carousel";

import ProductTVValue from "../ProductTVValue/ProductTVValue";

import "@brainhubeu/react-carousel/lib/style.css";
import Title from "../../Titles/Title/Title";
import HorizontalScroll from "../../../shared/HorizontalScroll/HorizontalScroll";
import List from "../List/List";

const ProductTVList = ({ productTVValues, onClick, media }) => {
  const productTVList = productTVValues.map(producctTVValue => (
    <ProductTVValue
      key={producctTVValue.category}
      productTVValue={producctTVValue}
      onClick={onClick}
    />
  ));

  return (
    <List paddingBottom={0} paddingRight={0}>
      <Title
        marginLeft={media.mobile || media.tablet ? "10%" : "4%"}
        marginBottom={media.mobile || media.tablet ? "9%" : "10%"}
      >
        <h1>Claro TV Pré-pago</h1>
      </Title>
      {media.mobile || media.tablet ? (
        <HorizontalScroll>{productTVList}</HorizontalScroll>
      ) : (
        <Carousel itemWidth={280}>{productTVList}</Carousel>
      )}
    </List>
  );
};

ProductTVList.propTypes = {
  productTVValues: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  media: PropTypes.object.isRequired,
};

ProductTVList.defaultProps = {
  productTVValues: [],
};

export default ProductTVList;
